import React from 'react';

export const WarningIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg width="32" height="27" viewBox="0 0 32 27" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fill="currentColor"
            d="M5.5 26.7c-1.6 0-3-.9-3.8-2.2a5.3 5.3 0 01-.2-4.9L11.7 3c1.1-1.7 2.6-3 4.8-3 2.2 0 3.7 1.4 4.8 3l10.1 16.5c.8 1.5.8 3.5-.1 5a4.5 4.5 0 01-3.8 2.2h-22zm11-8.7c.9 0 1.6.7 1.6 1.7s-.7 1.6-1.6 1.6c-.9 0-1.7-.7-1.7-1.6 0-.9.8-1.7 1.7-1.7zm0-1.6c-.6 0-1-.5-1.1-1.1l-.6-5c-.1-.9.8-1.6 1.7-1.6.9 0 1.8.8 1.6 1.6l-.6 5c0 .6-.4 1.1-1 1.1zm-11 8.1h21.9c.8 0 1.5-.5 1.9-1.1.5-.8.5-1.8.1-2.7l-10-16.4c-.7-1-1.6-2.1-3-2.1s-2.3 1-3 2.1l-10 16.4c-.4.9-.4 1.9.1 2.7.5.6 1.2 1.1 2 1.1z"
        />
    </svg>
);
